import constants from '../config/constants'

/**
 * Replaces numbers and special characters with a blank string
 **/
export const toPersonName = (rawInput: string) => {
  if (rawInput === undefined) {
    return ''
  }
  const p = /[0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]/g
  return rawInput.replace(p, '')
}

export const isValidPersonName = (name: string) => {
  return toPersonName(name).length >= constants.personNameMinLength
}

export const convertDateFormat = (date: any, short = true) => {
  const newDate = new Date(date)

  if (short) {
    const month = newDate.getMonth() + 1
    return month + '/' + newDate.getDate() + '/' + newDate.getFullYear()
  } else {
    const fullMonth = constants.date.months[newDate.getMonth()]
    return `${newDate.getDate()} ${fullMonth} ${newDate.getFullYear()}`
  }
}

/**
 * Converts min & max shipping date into a user-friendly shipping date format
 * Sample return: 2 Nov - 5 Nov
 */
export const shippingDate = (minDate: any, maxDate: any) => {
  const dateFrom = new Date(minDate)
  const dayFrom = dateFrom.getDate()
  const monthFrom = constants.date.months[dateFrom.getMonth()].substr(0, 3)

  const dateTo = new Date(maxDate)
  const dayTo = dateTo.getDate()
  const monthTo = constants.date.months[dateTo.getMonth()].substr(0, 3)

  return `${dayFrom} ${monthFrom} - ${dayTo} ${monthTo}`
}

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export const capitalize = (s: string) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

/**
 * Gets the ordinal number extension (st, nd, rd, th) from a given number
 * Credits to https://community.shopify.com/c/Shopify-Design/Ordinal-Number-in-javascript-1st-2nd-3rd-4th/m-p/72156
 */
export const getGetOrdinal = (n: number) => {
  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100
  return s[(v - 20) % 10] || s[v] || s[0]
}
